import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { createContext } from './createContext';
import { attachSocketToContext } from '../../utils';
import { openEventChannel } from '../../../shared/actions/socket';
import { AppContainer } from '../../../shared/containers/App';
import { attachReducers } from '../../../shared/reducers/attachReducers';
import { createAppStore } from '../../../shared/store/createAppStore';
import { TAppState } from '../../../shared/types/appState';
import { selectIsUserAuthenticated } from '../../../shared/selectors';
import {
  initPageActivityTracking,
  setInitialIsAuthenticated,
} from '../../../shared/utils/logging/publicApiDiagnostics';

export function runApp() {
  initPageActivityTracking();

  const context = createContext();
  const { config } = context;

  const initialState = config.getStrict<TAppState>('initialState');

  attachSocketToContext(context);

  const store = createAppStore({
    initialState,
    optionalParams: {
      dispatchReducerAddedAction: true,
      dispatchRunnerSagaAction: true,
    },
    context,
  });

  attachReducers(store);

  const rootElement = document.getElementById('frontend-chats');

  if (!rootElement) {
    throw new Error('Unable to find element #frontend-chats');
  }

  const state = store.getState();
  const isUserAuthenticated = selectIsUserAuthenticated(state);

  setInitialIsAuthenticated(isUserAuthenticated);

  if (isUserAuthenticated) {
    store.dispatch(openEventChannel());
  }

  hydrateRoot(rootElement, <AppContainer store={store} context={context} />);
}
